import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-bmi-summary-field',
  templateUrl: './bmi-summary-field.component.html',
})
export class BmiSummaryFieldComponent {

  @Input() label: string;
  @Input() height: number;
  @Input() weight: number;

  constructor() { }


}
